
export default {
  name: "payments",
  head(){
    return{
      title:'Τρόποι πληρωμής'
    }
  },
};
